/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_RegisterInputs */

const en_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Register`)
};

const es_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrarse`)
};

const de_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

const zh_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`报名`)
};

const ar_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجّل`)
};

const fr_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S’inscrire`)
};

const vi_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng ký`)
};

const sw_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jisajili`)
};

const th_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลงทะเบียน`)
};

const bs_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registruj se`)
};

const ja_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`申し込む`)
};

const ko_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`등록하기`)
};

const pt_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscrever-se`)
};

const it_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrati`)
};

const sv_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmäl dig`)
};

const nl_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inschrijven`)
};

const da_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilmeld dig`)
};

const nb_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meld deg på`)
};

const fi_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoittaudu`)
};

const pl_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarejestruj się`)
};

const ru_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зарегистрироваться`)
};

const tr_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaydol`)
};

const hi_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पंजीकरण करें`)
};

const id_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar`)
};

const ms_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar`)
};

const cs_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaregistrovat se`)
};

const el_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Εγγραφή`)
};

const he_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הירשמו`)
};

const af_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registreer`)
};

const hu_events_register = /** @type {(inputs: Events_RegisterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regisztráció`)
};

/**
* | output |
* | --- |
* | "Register" |
*
* @param {Events_RegisterInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const events_register = /** @type {((inputs?: Events_RegisterInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_RegisterInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_events_register(inputs)
	if (locale === "de") return de_events_register(inputs)
	if (locale === "zh") return zh_events_register(inputs)
	if (locale === "ar") return ar_events_register(inputs)
	if (locale === "fr") return fr_events_register(inputs)
	if (locale === "vi") return vi_events_register(inputs)
	if (locale === "sw") return sw_events_register(inputs)
	if (locale === "th") return th_events_register(inputs)
	if (locale === "bs") return bs_events_register(inputs)
	if (locale === "ja") return ja_events_register(inputs)
	if (locale === "ko") return ko_events_register(inputs)
	if (locale === "pt") return pt_events_register(inputs)
	if (locale === "it") return it_events_register(inputs)
	if (locale === "sv") return sv_events_register(inputs)
	if (locale === "nl") return nl_events_register(inputs)
	if (locale === "da") return da_events_register(inputs)
	if (locale === "nb") return nb_events_register(inputs)
	if (locale === "fi") return fi_events_register(inputs)
	if (locale === "pl") return pl_events_register(inputs)
	if (locale === "ru") return ru_events_register(inputs)
	if (locale === "tr") return tr_events_register(inputs)
	if (locale === "hi") return hi_events_register(inputs)
	if (locale === "id") return id_events_register(inputs)
	if (locale === "ms") return ms_events_register(inputs)
	if (locale === "cs") return cs_events_register(inputs)
	if (locale === "el") return el_events_register(inputs)
	if (locale === "he") return he_events_register(inputs)
	if (locale === "af") return af_events_register(inputs)
	if (locale === "hu") return hu_events_register(inputs)
	return en_events_register(inputs)
});